import { render } from "./BaseInputOTP.vue?vue&type=template&id=6d7f0a30&scoped=true"
import script from "./BaseInputOTP.vue?vue&type=script&lang=js"
export * from "./BaseInputOTP.vue?vue&type=script&lang=js"

import "./BaseInputOTP.vue?vue&type=style&index=0&id=6d7f0a30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d7f0a30"]])

export default __exports__